import z from "zod";

export const AmenitySchema = z.object({
  id: z.string(),
  name: z.string(),
  isBookable: z.boolean().optional(),
  canHaveMultiple: z.boolean().optional(),
  icon: z.string().optional(),
  description: z.string().optional(),
  count: z.number().optional(),
  tags: z.array(z.string()).optional(),
  exclusions: z.array(z.string()).optional(), // array of room ids when used in a room that cannot contain this amenity
  originalAmenityId: z.string().optional(), // reference to the global amenity this instance was created from (for canHaveMultiple amenities)
  hidden: z.boolean().optional(), // if true, amenity is hidden from users but kept for booking record integrity
});

export type Amenity = z.infer<typeof AmenitySchema>;

export interface AmenityFilters {
  // ids
  amenityId?: string;
  searchTerm?: string;
}

export interface AmenitySort {
  field: "name" | "isBookable" | "count";
  order: "asc" | "desc";
}
